import { FC } from 'react';
import { useForm } from 'react-hook-form';

import {
  initContractFormFields,
  type ContractFormFields,
} from 'page/CustomerPage/types/contractFormField';
import { useContractRegistrationStore } from 'page/CustomerPage/hooks';
import { InputModal } from './InputModal';
import { ConfirmationModal } from './ConfirmationModal';

export const ContractRegistrationModal: FC = () => {
  const {
    init: initRegistration,
    goInputModal,
    goConfirmationModal,
    setForm,
    postContractAndReload,
  } = useContractRegistrationStore();

  const { formState, register, getValues, reset } = useForm<ContractFormFields>(
    {
      defaultValues: initContractFormFields,
      mode: 'all',
    },
  );

  /**
   * モーダルを閉じたときにおこなう一連の初期化処理
   */
  const initState = () => {
    // フォームをリセット
    reset();
    // 登録画面の state を初期化
    initRegistration();
  };

  /**
   * 入力モーダル・確認モーダルで右上の「×」ボタンをクリックしたときの処理
   */
  const handleClose = () => {
    // 初期化
    initState();
  };

  /**
   * 入力モーダルで「確認」ボタンをクリックしたときの処理
   */
  const handleClickGoConfirmation = () => {
    // フォームの内容を state に保存
    setForm(getValues());
    // 確認モーダルに進む
    goConfirmationModal();
  };

  /**
   * 確認モーダルで「入力画面に戻る」ボタンをクリックしたときの処理
   */
  const handleClickGoInput = () => {
    // 入力モーダルに戻る
    goInputModal();
  };

  /**
   * 確認モーダルで「登録ボタン」をクリックしたときの処理
   */
  const handleClickRegistration = () => {
    // お知らせ登録処理＆一覧をリロード
    void postContractAndReload();
    // 初期化
    initState();
  };

  return (
    <>
      {/* 入力モーダルコンテナ */}
      <InputModal
        formState={formState}
        register={register}
        handleClose={handleClose}
        handleClickGoConfirmation={handleClickGoConfirmation}
      />
      {/* 確認モーダルコンテナ */}
      <ConfirmationModal
        handleClose={handleClose}
        handleClickGoInput={handleClickGoInput}
        handleClickRegistration={handleClickRegistration}
      />
    </>
  );
};
